export const APP_USER_QUERY_KEY = "app-user" as const;
